import { Progress } from "antd";
import SignOutIcon from "assets/icons/sign-out.png";
import ButtonCustom from "components/base/ButtonCustom";
import { avatarDefault } from "contants/config";
import { PATH } from "contants/path";
import { useAppSelector } from "hooks/app-hook";
import { useLogout } from "hooks/useLogout";
import { Link } from "react-router-dom";
import { selectUsername } from "store/auth";
import { selectDataVipMember } from "store/member";
import { selectBalance, selectProfile } from "store/user";
import { theme } from "styles/theme";

import StyledHeaderMobileIsVerified from "./index.style";

const HeaderMobileIsVerified = () => {
  const handleLogout = useLogout();

  const username = useAppSelector(selectUsername);
  const balance = useAppSelector(selectBalance);
  const profile = useAppSelector(selectProfile);
  const dataMemberVip = useAppSelector(selectDataVipMember);

  return (
    <StyledHeaderMobileIsVerified>
      <div className="header__mobile-top">
        <div className="header --left-authentication">
          <div className="header__profile">
            <div className="header__profile-info">
              <Link to={PATH.user.account} className="avt">
                <div className="avatar-user">
                  <img src={profile?.avatar || avatarDefault} alt="" />
                </div>
                <div className="level-user">1</div>
                <div className="link-user">Profile</div>
              </Link>
              <div className="bag">
                <div className="flex mess">
                  <div className="name">VIP{dataMemberVip.current_level}</div>
                  <div className="status">
                    <Link
                      to={PATH.user.messages}
                      className="user-info__messages__link"
                    >
                      <span className="user-info__messages-count">0</span>
                      <span
                        data-has-message=""
                        className="user-info__messages-title"
                        style={{ display: "none" }}
                      >
                        New messages
                      </span>
                      <span
                        data-no-message=""
                        className="user-info__messages-title empty"
                        style={{ display: "block" }}
                      >
                        No messages
                      </span>
                    </Link>
                  </div>
                </div>
                <div className="flex balance">
                  <div className="name">Total balance:</div>
                  <div className="coin">{balance?.total} INR</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header --right">
          <div className="header__profile">
            <div className="header__profile-deposit">
              <ButtonCustom
                type="primary"
                background_color={theme.colors.secondary[900]}
                color="white"
                style={{ fontWeight: "bold " }}
              >
                <Link to={PATH.user.deposit}>Deposit</Link>
              </ButtonCustom>
            </div>
            <div className="header__profile-level">
              <Link to={PATH.user.account} className="username">
                {username}
              </Link>
              <div className="inner">
                <div className="profile-loyalty-level">
                  {dataMemberVip.current_level}
                </div>
                <div className="profile-loyalty-bar">
                  <div className="profile-loyalty-bar">
                    <Progress
                      percent={Number(
                        dataMemberVip.next_level?.turnover_percentage
                      )}
                    />
                  </div>
                </div>
              </div>
              <Link to={PATH.user.loyaltyProgram} className="achievement">
                Current Turnover
              </Link>
            </div>
          </div>
          <button className="header__login" onClick={handleLogout}>
            <div className="item">
              <img src={SignOutIcon} alt="" />
              <p>Exit</p>
            </div>
          </button>
        </div>
      </div>
    </StyledHeaderMobileIsVerified>
  );
};

export default HeaderMobileIsVerified;
